<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('Locked Records')}}</div>
        </div>
        <van-empty :description="$t('moneybag.detailsEmpty')" v-if="!data || data.length === 0" />
        <div class="detail_box">
            <div class="item" v-for="item in data">
                <div class="de_wrap">
                    <p class="tit">【{{item.name}}】</p>
                    <p class="tit">{{$t('Deposit payable due is locked')}}</p>
                    <p class="time">{{$t('Unlocking time')}}:{{item.thaw_time}}</p>
                </div>
                <div class="price del" v-html="$t('currency')+item.money"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem);

    export default {
        name: "locked",
        data() {
            return {
                lang:this.$i18n.locale||"en_us",
                data: [],
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            Fetch('/user/locked').then(r => {
                this.data = r.data.list;
            })
        },
        methods: {

        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg {
        /*height: 126px;*/
        background: #76b900;
        position: fixed;
    }
    .user_yw{
        text-align: center;
        width: 96%;
        position: absolute;
        top: 78px;
        background: #FFFFFF;
        left: 2%;
        border-radius: 5px 5px 0 0;
        padding: 20px 0;
        p:nth-child(1){
            font-size: 16px;
            color: #646566;
            margin-bottom: 20px;
        }
        p:nth-child(2){
            font-size: 20px;
            font-weight: bold;
        }
    }
    .user_zrzc{
        text-align: center;
        width: 96%;
        position: absolute;
        top: 173px;
        background: #FFFFFF;
        left: 2%;
        border-radius: 0 0 5px 5px;
        padding: 15px 0;
        display: flex;
        justify-content: space-between;
        text-align: center;
        span{
            /*width: 40%;*/
            width:100%;
            background: #76b900;
            color: #000;
            margin: 0px 20px;
            padding: 12px 10px;
            border-radius: 5px;
            font-size: 14px;
        }
    }

    .detail_box {
        width: 96%;
        margin-left: 2%;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        padding: 0 8px;
        margin-top: 60px;
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 8px;
            border-bottom: 1px solid #ECECEC;

            .de_wrap {
                flex: 2;

                .tit {
                    font-size: 14px;
                    color: rgba(0,0,0,.8);
                    line-height: 20px;
                    font-weight: bold;
                }

                .time {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 17px;
                    margin-top: 10px;
                }
            }

            .price {
                flex: 1;
                font-size: 20px;
                line-height: 28px;
                font-weight: bold;
                text-align: right;
                color: #f12211;
                white-space: nowrap;
                &.del {
                    color: #3FAF3E;
                }
            }
        }
    }
</style>
